import { Component, computed, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-main-page',
  templateUrl: './main.page.html',
  styleUrl: './main.page.scss',
  imports: [
    ButtonModule,
    MenuModule,
    RouterModule,
  ],
})
export class MainPage {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public readonly menuItems = computed<MenuItem[]>(() => {
    const user = this.authService.user();
    const items: MenuItem[] = [
      {
        label: 'Übungen',
        icon: 'pi pi-book',
        routerLink: ['/exercises'],
      },
      {
        label: 'Patienten',
        icon: 'pi pi-user',
        routerLink: ['/patients'],
      },
      {
        label: 'Mediathek',
        icon: 'pi pi-images',
        routerLink: ['/files'],
      },
    ];

    // Only admins can manage users
    if (user?.role === 'ADMIN') {
      items.push({
        label: 'Benutzer',
        icon: 'pi pi-users',
        routerLink: ['/users'],
      });
    }

    return items;
  });

  public logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }
}
